import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import LoginPage from './LoginPage';

type TParams = { id: string, url: string }

function Login({ match }: RouteComponentProps<TParams>) {
    return (
        <Switch>
            <Route exact path={`${match.url}`} component={LoginPage} />
        </Switch>
    );
}

export default Login;
